/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseAccordionFragment, AccordionFragment, FullAccordionFragment} from '@amblique/contentful/app/contentful/fragments/accordion';

/**
 * Get a single Accordion by ID (base - scalars only)
 */
export const getBaseAccordionById = gql`
  ${BaseAccordionFragment}

  query GetBaseAccordionById($id: String!, $locale: String!, $preview: Boolean) {
    accordion(id: $id, locale: $locale, preview: $preview) {
      ...BaseAccordionFragment
    }
  }
`;

/**
 * Get a single Accordion by ID (standard - 1 level deep)
 */
export const getAccordionById = gql`
  ${AccordionFragment}

  query GetAccordionById($id: String!, $locale: String!, $preview: Boolean) {
    accordion(id: $id, locale: $locale, preview: $preview) {
      ...AccordionFragment
    }
  }
`;

/**
 * Get a single Accordion by ID (full - 2 levels deep)
 */
export const getFullAccordionById = gql`
  ${FullAccordionFragment}

  query GetFullAccordionById($id: String!, $locale: String!, $preview: Boolean) {
    accordion(id: $id, locale: $locale, preview: $preview) {
      ...FullAccordionFragment
    }
  }
`;

/**
 * Get all Accordion entries with pagination (base - scalars only)
 */
export const getBaseAccordions = gql`
  ${BaseAccordionFragment}

  query GetBaseAccordions(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AccordionOrder]
    $where: AccordionFilter
    $preview: Boolean
  ) {
    accordionCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseAccordionFragment
      }
    }
  }
`;

/**
 * Get all Accordion entries with pagination (standard - 1 level deep)
 */
export const getAccordions = gql`
  ${AccordionFragment}

  query GetAccordions(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AccordionOrder]
    $where: AccordionFilter
    $preview: Boolean
  ) {
    accordionCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...AccordionFragment
      }
    }
  }
`;

/**
 * Get all Accordion entries with pagination (full - 2 levels deep)
 */
export const getFullAccordions = gql`
  ${FullAccordionFragment}

  query GetFullAccordions(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [AccordionOrder]
    $where: AccordionFilter
    $preview: Boolean
  ) {
    accordionCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullAccordionFragment
      }
    }
  }
`;
